import { API } from "../../../utils";

export const getAppSettings = async () => {
  const res = await API.get(`app-settings`);
  return res.data;
};

export const updateAppSettings = async (payload) => {
  const res = await API.post(`app-settings`, payload);
  return res.data;
};
